module.exports = __webpack_public_path__ + "img/ENT_Course_4.31f0783c.jpg";